<app-breadcrumbs title="Insights" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>

<div class="row justify-content-center">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div class="text-end">
                    <button *ngIf="ownerId == model.createdById && hasBlogUpdate" (click)="editModal()" type="button"
                        class="btn btn-soft-primary" id="add-btn">
                        <span>Edit</span>
                    </button>
                </div>
                <div class="text-center mb-4">

                    <h4 class="mb-2">{{model.title}}</h4>

                
                    <div class="d-flex align-items-center justify-content-center flex-wrap gap-2">
                        <span *ngFor="let tag of model.tags"
                            class="badge coloredTextArea blue text-primary">{{tag}}</span>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-lg-2">
                        <h6 class="pb-1">Contributed By:</h6>
                        <div class="d-flex gap-2 mb-3">
                            <div class="flex-shrink-0">
                                <img [src]="profileImageURL"
                                    class="rounded-circle avatar-sm img-thumbnail user-profile-image"
                                    alt="user-profile-image">
                            </div>
                            <div class="flex-grow-1">
                                <h5 class="mb-1">{{model.createdByName}}</h5>
                                <!-- <p class="mb-2">
                                    <span *ngFor="let role of creator.roles">{{role}}, </span>
                                </p> -->

                                <p class="text-muted mb-0">{{model.publishDate| amTimeAgo:true}} </p>
                            </div>
                        </div>
                        <h6 class="text-muted mb-4">
                            <span *ngFor="let category of model.categories">{{category}} </span>
                        </h6>
                    </div>
               
                    <div class="col-lg-10" >
                        <app-rich-text-displayer  [textToDisplay]="model.blogText"></app-rich-text-displayer>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12">
        <span *ngIf="model.id != undefined">
            <app-file-management [entityId]="model.id" [entityTypeId]="entityTypeId"  [customTable] = "attachmentsConfig"
                [customTitle]="'Attachments'"></app-file-management>
        </span>
        <span *ngIf="model.id == undefined">
            <app-file-management [customTitle]="'Attachments'" [filesIdsToAdd]="model.fileUpload.fileIdsToAdd"
                [entityFiles]="model.fileUpload.entityFiles"></app-file-management>
        </span>
    </div>
</div>